import StyleSheetRW from "core/StyleSheetRW";
import { rh } from "core/designHelpers";
const styles = StyleSheetRW.create(() => ({
    outer:{ display: "flex", flexDirection: "row", height: "100%" },
    inner:{
    scrollbarWidth:'none',
    overflowX: "hidden",
    padding: "0px 0px 0px 20px",},
    review:{              width: "100%",
        fontSize: 36,
        fontWeight: "700",
        color: "#2F4858",},
        startBorder:{ borderLeft: '0px', padding: '15px' },
    endBar:{height:'100%',display:'flex',flexDirection:'row',justifyContent:'space-evenly',alignItems:'center'},
    tableEndCell:{ borderLeft: '1px solid #2F485880', padding: '15px' },
    tableCell:{ borderLeft: '1px solid #2F485880', padding: '15px' },
    tableHead:{ border: "1px solid black", padding: "15px" },
    tableHeadRow:{ backgroundColor: "#2F4858", color: "#FFFFFF", fontSize: 14},
    assigned:{ overflow: "scroll",scrollbarWidth:'none' },
    assignedText:{
        textAlign: "center",
        width: "100%",
        fontSize: 36,
        fontWeight: "700",
        marginTop:30,
        color: "#2F4858",
      },
    table:  {              marginTop:20,
    marginBottom: 20,
    borderCollapse: "collapse",
    backgroundColor: "#FFFFFF66",
    width: "100%",},
    addFeedbackModalContainer: {
      position: "absolute",
      top: "20%",
      bottom: "40%",
      padding: 20,
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#ffffff",
      borderRadius: 24,
      opacity: 1,
      transition: "opacity 0.3s ease",
      zIndex: 1,
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      width: "299px",
      alignSelf: "center",
    },
    ViewFeedbackModalContainer: {
      position: "absolute",
      top: "20%",
      bottom: "20%",
      padding: 20,
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#ffffff",
      borderRadius: 24,
      opacity: 1,
      transition: "opacity 0.3s ease",
      zIndex: 1,
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      width: "400px",
      alignSelf: "center",
      height: "500px",
    },
    addFeedbackModalHeading: {
      fontFamily: "Outfit",
      fontSize: 20,
      fontWeight: "bold",
      textAlign: "center",
      color: "#2F4858",
    },
    feedbackButton: {
      backgroundColor: "#ffffff",
      alignSelf: "center",
      borderRadius: 100,
      color: "#2F4858",
      fontWeight: "300",
      textAlign: "center",
      borderWidth: 0,
      width: "80px",
      height: "30px",
      margin: 5,
      cursor: "pointer",
    },
    AddfeedbackModalTextArea: {
      height: 100, // Set the desired height of the text area
      borderRadius: 10,
      paddingHorizontal: 10,
      paddingVertical: 10,
      backgroundColor: "#0000000D",
      marginTop: 3,
    },
    AddFeedbackModalLabel: {
      fontFamily: "Outfit",
      fontSize: 14,
      fontWeight: "600",
      lineHeight: 17.64,
      textAlign: "left",
      marginTop: 10,
      marginBottom: 5,
      color: "#333333",
    },
    input: {
      height: 50,
      borderRadius: 10,
      paddingHorizontal: 10,
      backgroundColor: "#0000000D",
      marginTop: 3,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    addButton: {
      width:147,
      backgroundColor: "#2F4858",
      paddingVertical: 10,
      marginTop: 20,
      paddingHorizontal: 20,
      borderRadius: 100,
      color: "white",
      fontWeight: "300",
      textAlign: "center",
      borderWidth: 0,
      alignSelf: "center",
      height: "38px",
    },
    buttoneStyle: {
      backgroundColor: "#8c9ea2",
      borderRadius: 99,
      fontWeight: "lighter",
      fontSize: "14px",
      color: "white",
      width: "110px",
      height: "37px",
      border: "0",
    },
    button: {
      backgroundColor: "#2F4858",
      alignSelf: "center",
      borderRadius: 100,
      color: "white",
      fontWeight: "300",
      textAlign: "center",
      borderWidth: 0,
      width: "80px",
      height: "30px",
    },
    container: {
      flex: 1,
      width: "100%",
      height: "100%",
    },
    heading: {
      fontFamily: "Outfit",
      fontSize: 32,
      fontWeight: "bold",
      color: "#2F4858",
      width: "100%",
      textAlign: "center",
    },
    ViewfeedbackModalHeading: {
      fontFamily: "Outfit",
      fontSize: 32,
      fontWeight: "700",
      color: "#2F4858",
      textAlign: "left",
    },
    subheading: {
      fontFamily: "Outfit",
      fontSize: 18,
      fontWeight: "bold",
      color: "#2F4858",
      marginTop: 10,
    },
    form: {
      width: "100%",
      height: "100%",
      marginTop: 20,
    },
    row: {
      justifyContent: "space-between",
      marginBottom: 10,
      gap: 20,
    },
    inputContainer: {
      flex: 1,
      marginRight: 5,
    },
    addCandidateButtonText: {
      color: "white",
      fontWeight: "400",
      textAlign: "center",
    },
    line: {
      borderBottomWidth: 1,
      borderColor: "#2F4858",
      marginBottom: 10,
    },
    container2: {
      padding: 20,
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#ffffff",
      borderRadius: 24,
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
      alignSelf: "center",
      gap: 10,
    },
    filterLabel: {
      fontFamily: "Outfit",
      fontSize: 16,
      fontWeight: "600",
      color: "#333333",
      marginBottom: 5,
      marginTop: 10,
    },
    filterInput: {
      backgroundColor: "#0000000D",
      border: "none",
      height: 20,
      borderRadius: 10,
      padding: 10,
      fontFamily: "Outfit",
      fontSize: 14,
      fontWeight: "600",
      color: "#333333",
      outline: "none",
    },
  }));
  
export default styles;